import { render, staticRenderFns } from "./jigsaw.vue?vue&type=template&id=0b7bc11c&scoped=true&"
import script from "./jigsaw.vue?vue&type=script&lang=js&"
export * from "./jigsaw.vue?vue&type=script&lang=js&"
import style0 from "./jigsaw.vue?vue&type=style&index=0&id=0b7bc11c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7bc11c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7bc11c')) {
      api.createRecord('0b7bc11c', component.options)
    } else {
      api.reload('0b7bc11c', component.options)
    }
    module.hot.accept("./jigsaw.vue?vue&type=template&id=0b7bc11c&scoped=true&", function () {
      api.rerender('0b7bc11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/jigsaw.vue"
export default component.exports